import { SocialNetwork } from '@okletsplay/core';
import twitterIcon from 'assets/images/social/twitter.svg';
import telegramIcon from 'assets/images/social/telegram.svg';
import discordIcon from 'assets/images/social/discord.svg';
import mediumIcon from 'assets/images/social/medium.svg';
import facebookIcon from 'assets/images/social/facebook.svg';
import instagramIcon from 'assets/images/social/instagram.svg';
import twitchIcon from 'assets/images/social/twitch.svg';
import youtubeIcon from 'assets/images/social/youtube.svg';
import githubIcon from 'assets/images/social/github-white.svg';
import tiktokIcon from 'assets/images/social/tiktok-white.svg';

export const SOCIAL_NETWORK_ICONS: Record<SocialNetwork, string> = {
  twitter: twitterIcon,
  telegram: telegramIcon,
  discord: discordIcon,
  medium: mediumIcon,
  facebook: facebookIcon,
  instagram: instagramIcon,
  twitch: twitchIcon,
  youtube: youtubeIcon,
  tiktok: tiktokIcon,
  github: githubIcon,
};
